import {
  UPDATE_TOKEN,
  UPDATE_URL,
  UPDATE_BASE_URL,
  UPDATE_SERVER_URL,
  UPDATE_SOCKET_URL,
  UPDATE_SOCKETCLUSTER_URL,
  UPDATE_IMAGES_PATH,
  UPDATE_AUTHORIZED_USER,
  UPDATE_AUTHORIZED_USER_SETTINGS,
  UPDATE_AUTHORIZATION_STATE,
  UPDATE_AUTHORIZED_USER_SCREEN_NAME,
  UPDATE_AUTHORIZED_USER_AVATAR,
  LOGOUT,
  LOGIN
} from 'constants';

import { fetchDispatcher } from 'api';
import { joinSocketChannel , leaveSocketChannel } from './socket';

export const userLoggedOut = () => {
  return {
    type: UPDATE_AUTHORIZATION_STATE,
    payload: { logged_in: false }
  }
}

export const userLoggedIn = () => {
  return {
    type: UPDATE_AUTHORIZATION_STATE,
    payload: { logged_in: true }
  }
}

export const updateToken = (token) => {
  return { type: UPDATE_TOKEN, payload: { token } };
}

export const updateUrl = (url) => {
  return { type: UPDATE_URL, payload: { url } };
}

export const updateUser = (user) => {
  return { type: UPDATE_AUTHORIZED_USER, payload: { user } };
}

export const updateUserSettings = (settings) => {
  return {
    type: UPDATE_AUTHORIZED_USER_SETTINGS,
    payload: settings
  };
}

export const updateUserScreenName = ({ screen_name }) => {
  return {
    type: UPDATE_AUTHORIZED_USER_SCREEN_NAME,
    payload: { screen_name }
  }
}
export const updateUserAvatar = ({ avatar }) => {
  return {
    type: UPDATE_AUTHORIZED_USER_AVATAR,
    payload: { avatar }
  }
}

export const updateBaseUrl = (baseUrl) => {
  return { type: UPDATE_BASE_URL, payload: { baseUrl } };
}

export const updateServerUrl = (serverUrl) => {
  return { type: UPDATE_SERVER_URL, payload: { serverUrl } };
}

export const updateImagesPath = (imagesPath) => {
  return { type: UPDATE_IMAGES_PATH, payload: { imagesPath } };
}

export const updateSocketUrl = (socketUrl) => {
  return { type: UPDATE_SOCKET_URL, payload: { socketUrl } }
}

export const updateSocketClusterUrl = (socketCluster) => {
  return { type: UPDATE_SOCKETCLUSTER_URL, payload: { socketCluster } }
}

export const signup = (properties, callback) => {
  return (dispatch) => {
    callApi('POST', '/user/signup', properties, 'application/json')
      .then(({ message, status }) => {
        if (typeof callback === 'function')
          callback(null, { message, status });
      })
      .catch(error => {
        if (typeof callback === 'function')
          callback(error, null);
      });
  }
}

export const login = (creds, callback) => ({
	type : LOGIN,
	payload : {...creds},
  callback
});

export const logout = () => ({ type : LOGOUT });

export const getCurrentUser = (callback) => {
  return (dispatch, getState) => {
    var connection = getState().connection;
    callApi('GET', '/user', null, 'application/json')
      .then(user => {
        dispatch(updateUser(user));
        if (typeof callback === 'function') callback(null, user);
      })
      .catch(error => {
        if (typeof callback === 'function')
          callback(error, null);
      });
  }
}


//Fetch:
// Takes same options afforded in the $.ajax method.
export const fetch = (options) => {
  return (dispatch, getState) => {
    fetchDispatcher(Object.assign({}, options, {
      dispatch,
      getState
    }));
  }
}



// WEBPACK FOOTER //
// ./src/common/actions/connect.js